import EventBase from './EventBase'
import EventID from './EventID'
import EventIF, {
  FlowerClass,
  IFType,
  LimitMallClass,
  MallClass,
  MouseClass,
  PayClass,
  PlateFormClass,
  PlateType,
  TaskClass,
  VarClass,
  VarExClass,
} from './EventIF'

/**
 * 217  -  高级条件分歧
 */
import { FileReader, FileWriter } from '@/platform'

export default class EventSeniorIF extends EventBase {
  /**
   * 构造函数
   */
  constructor() {
    super()
    this.Parameter = ['0', '0', '', '0', '', '']
  }

  readData(reader: FileReader) {
    this.Code = reader.readInt()
    this.Indent = reader.readInt()
    this.EventLength = reader.readInt()
    for (let i = 0; i < this.EventLength; i++) {
        this.Parameter[i] = reader.readString()
    }
    this.InitIfItems()
  }

  public writeData(writer: FileWriter): void {
    writer.writerIntLength()
    writer.writeInt(this.Code)
    writer.writeInt(this.Indent)
    writer.writeInt(this.EventLength)
    for (let i = 0; i < this.EventLength; i++) {
      writer.writeString(this.Parameter[i] ?? '')
    }
    writer.writerLength()
  }

  // #region 事件中主要属性参数
  /**
   * 0（或者）、1（并且）
   */
  get IsAlso() {
    return this.Parameter?.[0] == '1'
  }
  set IsAlso(value) {
    this.Parameter && (this.Parameter[0] = value ? '1' : '0')
  }

  /**
   * 0(无else)、1（有else）
   */
  get IsElse() {
    return this.Parameter?.[1] == '1'
  }
  set IsElse(value) {
    this.Parameter && (this.Parameter[1] = value ? '1' : '0')
  }

  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[2] ?? ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[2] = value.toString())
  }

  /**
   * 共几个条件项
   */
  get Count() {
    return parseInt(this.Parameter?.[3] ?? '')
  }
  set Count(value) {
    this.Parameter && (this.Parameter[3] = value.toString())
  }

  public ifItem: Array<EventIF> = []
  /**
   * 条件分歧项
   */
  get IfItem() {
    return this.ifItem
  }
  set IfItem(value) {
    this.ifItem = value
    if (this.ifItem != null && this.Parameter != null) {
      const addCount = 4
      const para = this.Parameter
      this.Parameter = []
      this.Parameter[0] = para[0]
      this.Parameter[1] = para[1]
      this.Parameter[2] = para[2]
      this.Parameter[3] = para[3]
      for (let i = 0; i < this.ifItem.length; i++) {
        if (this.ifItem[i] != null) {
          switch (this.ifItem[i].Type) {
            case IFType.VarIndex:
              const variable = this.ifItem[i] as VarClass
              if (variable != null) {
                this.Parameter[
                  addCount + i
                ] = `${variable.VarIndex}&${variable.RelationIndex}&${variable.CmpObject}&${variable.OperatNumber}&&${variable.Description}`
              }
              break
            case IFType.VarEx:
              const varEx = this.ifItem[i] as VarExClass
              if (varEx != null) {
                this.Parameter[
                  addCount + i
                ] = `EX|${varEx.VarIndex}&${varEx.RelationIndex}&${varEx.CmpObject}&${varEx.OperatNumber}&&${varEx.Description}`
              }
              break
            case IFType.Flower:
              const flower = this.ifItem[i] as FlowerClass
              if (flower != null) {
                this.Parameter[
                  addCount + i
                ] = `FL|${flower.VarIndex}&${flower.RelationIndex}&${flower.CmpObject}&${flower.OperatNumber}&&${flower.Description}&${flower.OperatNumberPakors}`
              }
              break
            case IFType.Mouse:
              const mouse = this.ifItem[i] as MouseClass
              if (mouse != null && mouse.RectInfo != null) {
                this.Parameter[addCount + i] = `MO|${mouse.VarIndex}&${
                  mouse.RectType
                }&${mouse.RectType === 1 ? mouse.PicID :
                  (mouse.RectInfo.X +
                  ',' +
                  mouse.RectInfo.Y +
                  ',' +
                  mouse.RectInfo.Width +
                  ',' +
                  mouse.RectInfo.Height)
                }&${mouse.IsPressedDown ? '1' : '0'}&&${mouse.Description}`
              }
              break
            case IFType.Pay:
              const pay = this.ifItem[i] as PayClass
              if (pay != null) {
                this.Parameter[addCount + i] = `PA|${pay.VarExIndex}&${
                  pay.IsResuption ? '1' : '0'
                }&${pay.PurchasID}&0&&${pay.Description}`
              }
              break
            case IFType.Platform:
              const platform = this.ifItem[i] as PlateFormClass
              if (platform != null) {
                this.Parameter[
                  addCount + i
                ] = `PT|${platform.VarIndex}&0&0&${platform.PlateType}&&${platform.Description}`
              }
              break
            case IFType.Task:
              const task = this.ifItem[i] as TaskClass
              if (task != null) {
                this.Parameter[addCount + i] = `0&6&0&0&&${task.Description}`
              }
              break
            case IFType.Mall:
              const mall = this.ifItem[i] as MallClass
              if (mall != null) {
                this.Parameter[
                  addCount + i
                ] = `ST|&0&${mall.GoodsID}&0&&${mall.Description}`
              }
              break
            case IFType.LimiteMall:
              const limitMall = this.ifItem[i] as LimitMallClass
              this.Parameter[addCount + i] = `LT|&0&${limitMall.GoodsID}&0&&${limitMall.Description}`
              break;
          }
        }
      }
    }
  }

  public InitIfItems() {
    this.ifItem = new Array<EventIF>()
    if (this.Parameter != null && this.Parameter.length > 4) {
      for (let i = 4; i < this.Parameter.length; i++) {
        const tempArr = this.Parameter[i].split('&')
        if (tempArr != null && tempArr.length > 1) {
          if (tempArr.length == 7) {
            if (tempArr[0].startsWith('FL|')) {
              const tempIfEvent = new FlowerClass();
              tempIfEvent.Init(tempArr);
              this.ifItem.push(tempIfEvent);
            } else if (tempArr[6].startsWith("TA|")) {
              const tempIfEvent = new TaskClass
              tempIfEvent.IsHaveElse = tempArr[4] == "1"
              tempIfEvent.Description = tempArr[5]
              if (tempArr[6]) {
                  const tmpArr = tempArr[6].split('|').filter(Boolean)
                  let tempTaskID = parseInt(tempArr[1])
                  if (tmpArr != null && tmpArr.length == 2 && !isNaN(tempTaskID)) {
                      tempIfEvent.TaskID = tempTaskID
                  }
              }
              this.ifItem.push(tempIfEvent);
            }
          } else if (tempArr.length == 6) {
            let tempVarIndex = parseInt(tempArr[0])
            if (!isNaN(tempVarIndex)) {
              let tempIfEvent = new VarClass()
              tempIfEvent.VarIndex = tempVarIndex
              if (tempArr[1]) {
                tempIfEvent.RelationIndex = parseInt(tempArr[1])
              }
              if (tempArr[3]) {
                tempIfEvent.CmpObject = parseInt(tempArr[2])
              }
              tempIfEvent.OperatNumber = tempArr[3]
              tempIfEvent.IsHaveElse = tempArr[4] == '1' ? true : false
              tempIfEvent.Description = tempArr[5]
              this.ifItem.push(tempIfEvent)
            } else {
              if (tempArr[0].indexOf('EX|') === 0) {
                const tempIfEvent = new VarExClass()
                if (tempArr[0]) {
                  const tmpArr = tempArr[0].split('|').filter(Boolean)
                  let tempEventID = parseInt(tmpArr[1])
                  if (
                    tmpArr != null &&
                    tmpArr.length == 2 &&
                    !isNaN(tempEventID)
                  ) {
                    tempIfEvent.VarIndex = tempEventID
                  }
                }
                if (tempArr[1]) {
                  tempIfEvent.RelationIndex = parseInt(tempArr[1])
                }
                if (tempArr[2]) {
                  tempIfEvent.CmpObject = parseInt(tempArr[2])
                }
                tempIfEvent.OperatNumber = tempArr[3]
                tempIfEvent.IsHaveElse = tempArr[4] == '1'
                tempIfEvent.Description = tempArr[5]
                this.ifItem.push(tempIfEvent)
              } else if (tempArr[0].indexOf('FL|') === 0) {
                const tempIfEvent = new FlowerClass()
                if (tempArr[1]) {
                  tempIfEvent.RelationIndex = parseInt(tempArr[1])
                }
                if (tempArr[2]) {
                  tempIfEvent.CmpObject = parseInt(tempArr[2])
                }
                tempIfEvent.OperatNumber = tempArr[3]
                tempIfEvent.IsHaveElse = tempArr[4] == '1' ? true : false
                tempIfEvent.Description = tempArr[5]
                this.ifItem.push(tempIfEvent)
              } else if (tempArr[0].indexOf('MO|') === 0) {
                const tempIfEvent = new MouseClass()
                if (tempArr[1]) {
                  tempIfEvent.RectType = parseInt(tempArr[1])
                }
                tempIfEvent.PicID = tempArr[2]
                tempIfEvent.IsPressedDown = tempArr[3] == '1' ? true : false
                tempIfEvent.IsHaveElse = tempArr[4] == '1' ? true : false
                tempIfEvent.Description = tempArr[5]
                this.ifItem.push(tempIfEvent)
              } else if (
                tempArr[0].indexOf('PA|') === 0 ||
                tempArr[0].indexOf('PA|EX|') === 0
              ) {
                const tempIfEvent = new PayClass()
                if (tempArr[0]) {
                  const tmpArr = tempArr[0].split('|').filter(Boolean)
                  let tempEventID = parseInt(tmpArr[tmpArr.length - 1])
                  if (
                    tmpArr != null &&
                    (tmpArr.length == 2 || tmpArr.length == 3) &&
                    !isNaN(tempEventID)
                  ) {
                    tempIfEvent.VarExIndex = tempEventID
                  }
                }
                tempIfEvent.IsResuption = tempArr[1] == '1' ? true : false
                if (tempArr[2]) {
                  tempIfEvent.PurchasID = parseInt(tempArr[2])
                }
                tempIfEvent.IsHaveElse = tempArr[4] == '1' ? true : false
                tempIfEvent.Description = tempArr[5]
                this.ifItem.push(tempIfEvent)
              } else if (tempArr[0].indexOf('PT|') === 0) {
                const tempIfEvent = new PlateFormClass()
                switch (tempArr[3]) {
                  case '1':
                    tempIfEvent.PlateType = PlateType.PC
                    break
                  case '2':
                    tempIfEvent.PlateType = PlateType.WEB
                    break
                  case '3':
                    tempIfEvent.PlateType = PlateType.ANDROID
                    break
                  case '4':
                    tempIfEvent.PlateType = PlateType.IOS
                    break
                  case '5':
                    tempIfEvent.PlateType = PlateType.H5
                    break
                }
                tempIfEvent.IsHaveElse = tempArr[4] == '1' ? true : false
                tempIfEvent.Description = tempArr[5]
                this.ifItem.push(tempIfEvent)
              } else if (tempArr[0].indexOf('ST|') === 0) {
                const mall = new MallClass()
                mall.GoodsID = parseInt(tempArr[2])
                mall.Description = tempArr[5]
                this.ifItem.push(mall)
              } else if (tempArr[0].indexOf('LT|') === 0) {
                const limitMall = new LimitMallClass()
                limitMall.GoodsID = parseInt(tempArr[2])
                limitMall.Description = tempArr[5]
                this.ifItem.push(limitMall)
              }
            }
          }
        }
      }
    }
  }

  //   // #endregion

  /**
   * 事件ID
   */
  Code = EventID.SeniorIf

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
